export default "__VITE_ASSET__4e00f5e7__"